import { render } from "./NavMenuItem.vue?vue&type=template&id=712bd726&scoped=true&ts=true"
import script from "./NavMenuItem.vue?vue&type=script&lang=ts"
export * from "./NavMenuItem.vue?vue&type=script&lang=ts"

import "./NavMenuItem.vue?vue&type=style&index=0&id=712bd726&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-712bd726"]])

export default __exports__